import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { signOut } from 'firebase/auth';
import { useAuthState } from 'react-firebase-hooks/auth';
import { Link } from 'react-router-dom';
import auth from '../../../../firebase.init';
import logo from '../../../../Images/logo.png'
import CustomLink from '../CustomLink/CustomLink';
import './Header.css'

const Header = () => {
  const [user] = useAuthState(auth);

  const handleSignOut = () => {
    signOut(auth);
  }

  return (
    <header>
      <div className="container">
        <Navbar expand="lg">
          <Container>
            <Navbar.Brand as={Link} to='/' className='d-flex align-items-center text-white '><img src={logo} className='img-fluid logos me-3' width={100} alt="" />Corporate Sales Trainer</Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ms-auto">
                <Nav.Link as={CustomLink} className='me-3' to='/'>Home</Nav.Link>
                <Nav.Link as={CustomLink} className='me-3' to='/checkout'>Checkout</Nav.Link>
                <Nav.Link as={CustomLink} className='me-3' to='/blogs'>Blogs</Nav.Link>
                <Nav.Link as={CustomLink} className='me-3' to='/about'>About</Nav.Link>
                {user ?
                  <Nav.Link as={Link} className='text-white' onClick={handleSignOut} to='#'>Sign Out</Nav.Link>
                  :
                  <Nav.Link as={CustomLink} to='/login'>Log in</Nav.Link>
                }


              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    </header>
  );
};

export default Header;